import * as React from 'react';

import { ITaPoi, TTaCategory } from '../../../../types/infrastructure';
import { TA_ICON_MAP } from '../../constants';
import * as styles from './styles.css';

export interface ITaPinProps {
  category: TTaCategory;
  poi: ITaPoi;
}

/** Пин точки транспортной доступности; станции метро подкрашиваются цветом линии. */
export function TaPin({ category, poi }: ITaPinProps): React.JSX.Element {
  const Icon = TA_ICON_MAP[category];

  return (
    <div
      className={styles['pin']}
      data-poi-type={category}
      data-testid="district-infrastructure-map-ta-pin"
      style={poi.lineColor ? { backgroundColor: poi.lineColor } : undefined}
      title={poi.title}
    >
      <Icon color="icon-inverted-default" />
    </div>
  );
}
